(() => {
  const desktop = window.matchMedia('(min-width: 1000px)');

  const syncFilterState = (button) => {
    const isOpen = button.getAttribute('aria-expanded') !== 'false';
    button.dataset.nativeFilterState = isOpen ? 'open' : 'closed';
  };

  const syncFilterTarget = (button) => {
    const section = button.closest('.shopify-section--main-collection');

    if (desktop.matches) {
      const sidebar = section?.querySelector('.facets-sidebar');

      if (sidebar?.id) {
        button.setAttribute('aria-controls', sidebar.id);
      }

      button.setAttribute(
        'aria-expanded',
        section?.classList.contains('native-sidebar-hidden') ? 'false' : 'true'
      );
    } else {
      button.setAttribute('aria-controls', 'facets-drawer');
      button.setAttribute('aria-expanded', 'false');
    }

    syncFilterState(button);
  };

  const initializeFilterButton = (button) => {
    if (button.dataset.nativeFilterStateReady === 'true') {
      syncFilterTarget(button);
      return;
    }

    button.dataset.nativeFilterStateReady = 'true';
    syncFilterTarget(button);

    new MutationObserver(() => syncFilterState(button)).observe(button, {
      attributes: true,
      attributeFilter: ['aria-expanded']
    });
  };

  const filterButtons = document.querySelectorAll('[data-native-filter-toggle]');
  filterButtons.forEach(initializeFilterButton);

  desktop.addEventListener('change', () => {
    filterButtons.forEach(syncFilterTarget);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-native-filter-toggle]');
    if (!button) return;

    initializeFilterButton(button);

    if (!desktop.matches) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const section = button.closest('.shopify-section--main-collection');
    if (!section) return;

    const sidebar = section.querySelector('.facets-sidebar');
    if (!sidebar) return;

    const hidden = section.classList.toggle('native-sidebar-hidden');
    button.setAttribute('aria-expanded', hidden ? 'false' : 'true');
    syncFilterState(button);
  }, true);
})();
document.addEventListener('click', (event) => {
  const swatch = event.target.closest('.native-card-swatches label:is(.color-swatch, .block-swatch)');
  if (!swatch) return;

  const inputId = swatch.getAttribute('for');
  const input = inputId ? document.getElementById(inputId) : null;
  const variantId = input?.dataset.variantId;
  const card = swatch.closest('product-card');
  const productLink = card?.querySelector('.product-title, .product-card__media');

  if (!variantId || !productLink?.href) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const variantUrl = new URL(productLink.href, window.location.origin);
  variantUrl.searchParams.set('variant', variantId);
  window.location.assign(variantUrl.href);
}, true);
// data-native-variant-link


document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-native-load-more]');
  if (!button) return;

  event.preventDefault();
  if (button.getAttribute('aria-busy') === 'true') return;

  const sectionId = button.dataset.nativeLoadMoreSection;
  const productList = document.getElementById(button.dataset.nativeLoadMoreList);
  const loadMoreContainer = button.closest('.native-load-more');
  if (!sectionId || !productList || !loadMoreContainer) return;

  const originalLabel = button.textContent;
  button.setAttribute('aria-busy', 'true');
  button.setAttribute('aria-disabled', 'true');
  button.textContent = button.dataset.nativeLoadingLabel;

  try {
    const requestUrl = new URL(button.href, window.location.origin);
    requestUrl.searchParams.set('section_id', sectionId);

    const response = await fetch(requestUrl, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);

    const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
    const nextProductList = documentFragment.getElementById(productList.id);
    if (!nextProductList) throw new Error('Collection product list was not found');

    const nextProducts = Array.from(nextProductList.children);
    nextProducts.forEach((product) => {
      product.removeAttribute('reveal-on-scroll');
      productList.append(product);
    });

    const nextLoadMoreContainer = documentFragment.querySelector('.native-load-more');
    if (nextLoadMoreContainer) {
      loadMoreContainer.replaceWith(nextLoadMoreContainer);
    } else {
      loadMoreContainer.remove();
    }
  } catch (error) {
    button.textContent = originalLabel;
    button.removeAttribute('aria-busy');
    button.removeAttribute('aria-disabled');
    console.error('Unable to load more collection products:', error);
  }
});
